import React from 'react';
import { ToastContainer as Container, Toast as Toaster } from 'react-bootstrap';
import { useUnit } from 'effector-react';
import styled from 'styled-components';

import { ToastProps } from './types';
import { removeToast, toastStore } from './ToastStore';

const ErrorContainer = styled(Container)`
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    z-index: 9999;

    /* Ensure only the last toast is visible */
    .toast:not(:last-child) {
        display: none !important;
    }

    .toast {
        min-width: 300px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border: none;
        border-radius: 0.5rem;
        background-color: #fff5f5;
        position: absolute !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
    }

    .toast-header {
        background-color: transparent;
        border: none;
        padding: 1rem 1rem 0.5rem;
    }

    .toast-body {
        padding: 0.5rem 1rem 1.5rem;
        color: #1e2022;
        text-align: center;
    }

    .btn-close {
        background-size: 0.7em;
        opacity: 0.7;
        transition: opacity 0.2s ease;
        position: relative;
        z-index: 9999;

        &:hover {
            opacity: 1;
        }
    }
`;

const Component: React.FC<ToastProps> = React.memo((props) => {
    const toasts = useUnit(toastStore);
    // Filter out insufficient minutes errors
    const filteredToasts = toasts.filter((toast) => {
        const isInsufficientMinutesError =
            toast.variant === 'error' &&
            (toast.message?.includes("You don't have enough minutes to process this audio") ||
                toast.message?.includes('insufficient minutes') ||
                toast.message?.includes('Insufficient Minutes') ||
                toast.message?.includes('Failed to start checkout process'));
        return !isInsufficientMinutesError;
    });

    const errorToasts = filteredToasts.filter((toast) => toast.variant === 'error');
    const regularToasts = filteredToasts.filter((toast) => toast.variant !== 'error');

    const handleCloseError = () => {
        // Remove all error toasts when closing any error toast
        errorToasts.forEach((toast) => removeToast(toast.id));
    };

    return (
        <>
            {errorToasts.length > 0 && (
                <ErrorContainer position="middle-center" className="toaster-z-index">
                    <Toaster style={{ margin: '0 auto' }}>
                        <Toaster.Header closeButton={false}>
                            <strong className="me-auto" style={{ fontSize: '1.25rem' }}>
                                Error
                            </strong>
                            <button type="button" className="btn-close" onClick={handleCloseError} aria-label="Close" />
                        </Toaster.Header>
                        <Toaster.Body>{errorToasts[0].message}</Toaster.Body>
                    </Toaster>
                </ErrorContainer>
            )}
            {regularToasts.length > 0 && (
                <Container position={props.postion ?? 'bottom-end'} className="toaster-z-index">
                    {regularToasts.map((toast) => (
                        <Toaster key={toast.id} onClose={() => removeToast(toast.id)} bg="light">
                            <Toaster.Header>
                                <strong className="me-auto">{toast.header}</strong>
                                <small>moment ago</small>
                            </Toaster.Header>
                            <Toaster.Body className="text-black">{toast.message}</Toaster.Body>
                        </Toaster>
                    ))}
                </Container>
            )}
        </>
    );
});

Component.displayName = 'ToastContainer';

export const ToastContainer: React.FC<ToastProps> = Object.assign(Component, {});
